import _ from 'lodash';
import Debug from '@/util/debug';
import Loading from '@/components/loading/Loading.vue';
import { GOAL_LEAD_GENERATION } from '@/services/GoalTypeService';

const debug = Debug('campaign-setup');

const EVENT_START = 'startDraftCreation';

export default {
  dependencies: [
    'goalTypeService',
  ],
  components: {
    loading: Loading,
  },
  props: {
    campaign: Object,
    showToggleButton: Boolean,
  },
  data() {
    return {
      loading: true,
      error: null,
      goal_types: [],
      GOAL_LEAD_GENERATION,
      displayNotificationFor: null,
    };
  },
  computed: {
    goalOpts() {
      return this.mapTranslation(this.goal_types);
    },
    visibleOptCount() {
      return Object.keys(this.goal_types).length;
    },
    leadPrivacyPolicyLinkRequired() {
      if (
        _.get(this.goal_types, `${GOAL_LEAD_GENERATION}.config.custom_privacy_policy_link`, false)
      ) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    const fin = () => {
      debug.info('finished loading. error: %o', this.error);
      this.loading = false;
      if (this.$route.params.id === 'new') {
        this.$refs.campaignSetupModal.show();
      }
    };

    Promise.all([
      this.goalTypeService.getOptions().then(res => this.goal_types = res),
    ])
    .then(fin)
    .catch(e => { this.error = e; fin(); });
  },
  methods: {
    mapTranslation(obj) {
      return Object.values(obj).map((t, v) => ({
        ...t,
        key: Object.keys(obj)[v],
        text: this.$t(`pos.setup.optimize-for.${Object.keys(obj)[v]}`),
      }));
    },
    start() {
      this.$emit(EVENT_START);
    },
    updateGoalType(goalType) {
      debug.info('Goal type, %j', goalType);
      if (
        this.getGoalTypeNotice(goalType)
        && this.displayNotificationFor !== goalType
      ) {
        this.displayNotificationFor = goalType;
        return;
      }

      this.campaign.goal_type = goalType;
      if (this.$refs.campaignSetupModal) {
        this.$refs.campaignSetupModal.hide();
      }
    },
    getGoalTypeNotice(goalType) {
      let res = '';
      if (goalType === GOAL_LEAD_GENERATION && this.leadPrivacyPolicyLinkRequired) {
        res = this.$t('pos.setup.notice_leads');
      }
      if (_.get(this.goal_types, `${goalType}.config.fbPageRequired`, null) === true) {
        if (res !== '') {
          res = `${res}<br/>`;
        }
        res = `${res}${this.$t('pos.setup.notice_fb_required')}`;
      }
      return res;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/campaign-setup/CampaignSetup.js